export default __webpack_public_path__ + "static/media/contact-paper-final-mob.2c57e15d.webp";